module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/a35c1b09880d75e4342a301dac655613.png";